module.exports = __webpack_public_path__ + "static/screencapture-sales-generator-ru-company-2018-07-2.0723e4f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/sg-site/thumb/screencapture-sales-generator-ru-company-2018-07-2.png
// module id = 263
// module chunks = 35783957827783 246384609461072